module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_8004.27b30b1e.png";